import {format} from 'date-fns';
import {GetExamRequestsParams} from 'domain/usecases/private/exam-results/get-exam-requests';
import {makeGetExamRequests} from 'main/factories/usecases/private/exam-results/get-exam-requests';
import {getTotalPages} from 'presentation/utils';

export const getExamRequests = async (params: GetExamRequestsParams) => {
	const {referenceDate} = params;
	const formattedDate = referenceDate ? format(new Date(referenceDate), 'MM/yyyy') : undefined;

	const response = await makeGetExamRequests().get({
		...params,
		referenceDate: formattedDate,
	});

	if (!response) {
		return {
			items: [],
			total: 0,
			pages: 0,
			groups: [],
		};
	}

	const totalPages = getTotalPages({
		totalItems: response.total,
		itemsPerPage: response.totalPerPage,
		limit: params.limit,
	});

	const filteredItemsListContents = {
		items: response?.result,
		total: response?.total,
		pages: totalPages,
	};

	return filteredItemsListContents;
};
